import { z } from 'zod'

export const addCompanySchema = z.object({
  companyName: z.string().min(1, 'Company name is required'),
  externalId: z.string().min(1, 'Chronograph ID is required'),
  sectorId: z.string().min(1, 'Sector is required'),
  countryId: z.string().optional(),
  stateId: z.string().optional(),
  primaryOwnerId: z.string().min(1, 'Primary owner is required'),
  secondaryOwnerId: z.string().optional(),
  primaryContactId: z.string().optional(),
  description: z.string().optional(),
})

export type AddCompanyFormValues = z.infer<typeof addCompanySchema>
